import { useNavigate } from "react-router-dom";

import { Layout } from "../shared/components/Layout";

import {
  backgroundBlue,
  rug,
  dino,
  door,
  monaDino,
  venusDino,
  paw,
  forestDino,
  vermeerDino,
  whereToGo,
} from "../assets/images";

import styles from "./HomePage.module.scss";
import { PreloadedImage } from "../shared/components/PreloadedImage";
import { HeaderBanner } from "../shared/components/HeaderBanner";

export default function HomePage() {
  const navigate = useNavigate();

  const goToServers = () => navigate("/servers");
  const goToProjects = () => navigate("/projects");

  return (
    <Layout
      customMainClass={styles.homeMain}
      background={backgroundBlue}
      showFooter
      darkMode
    >
      <div className={styles.scene}>
        <PreloadedImage
          src={rug}
          alt=""
          className={styles.rug}
          width={681}
          height={69}
        />

        <PreloadedImage
          src={monaDino}
          alt="Мона Лиза"
          className={styles.paintingLeftTop}
          width={104}
          height={104}
        />
        <PreloadedImage
          src={venusDino}
          alt="Венера"
          className={styles.paintingLeftBottom}
          width={104}
          height={107}
        />
        <PreloadedImage
          src={paw}
          alt="Лапа"
          className={styles.paintingRightTop}
          width={104}
          height={100}
        />
        <PreloadedImage
          src={forestDino}
          alt="Динозавр в лесу"
          className={styles.paintingRightBottom}
          width={104}
          height={96}
        />
        <PreloadedImage
          src={vermeerDino}
          alt="Дино с жемчужной серёжкой"
          className={styles.paintingCenter}
          width={133}
          height={165}
        />
        <div className={styles.doorLeft} onClick={goToServers}>
          <PreloadedImage
            src={door}
            alt="Проверить сервер"
            className={styles.doorImg}
            width={413}
            height={682}
            aspectRatio="413 / 682"
          />
          <HeaderBanner className={styles.sign}>Проверить сервер</HeaderBanner>
        </div>

        <div className={styles.doorRight} onClick={goToProjects}>
          <PreloadedImage
            src={door}
            alt="Перенести проекты"
            className={styles.doorImg}
            width={413}
            height={682}
            aspectRatio="413 / 682"
          />
          <HeaderBanner className={styles.sign}>Перенести проекты</HeaderBanner>
        </div>
        <PreloadedImage
          src={whereToGo}
          alt="Куда идешь?"
          className={styles.speechBubble}
          width={273}
          height={189}
        />
        <PreloadedImage
          src={dino}
          alt="Динозавр"
          className={styles.dino}
          width={325}
          height={380}
        />

        <div className={styles.bubbleWrapper}></div>
      </div>
    </Layout>
  );
}
